// Autogenerated file
export const organizationDocumentsPolicysEnum = {
    None: "None",
    WithUniversalTransferDocuments: "WithUniversalTransferDocuments",
};
export const organizationDocumentsPolicys = [
    { label: "Без политики", value: "None", intValue: 0 },
    { label: "С УПД", value: "WithUniversalTransferDocuments", intValue: 1 },
];
